import {TextField, TextFieldProps} from "@material-ui/core";
import React from "react";


export const AppInput: React.FC<TextFieldProps> = (props) => {
  return <TextField fullWidth {...props}  />
}
